<template>
  <div>
    <v-dialog
      :style="{'z-index':zIndexNotiDialog}"
      class="notification-dialogBox"
      v-model="showNotificationDialog"
      scrollable
      width="50vw"
      height="145vh">
      <v-card>
        <v-card-title>
          <span class="headline">{{ notification.title }}</span>
          <v-spacer></v-spacer>
          <span class="caption grey--text">{{ formatTimestamp(notification.createdAt) }}</span>
        </v-card-title>
        <v-card-text>
          <div class="notification-body"
            :style="{ color: 'black' }"
            v-for="(text, index) in linkifiedBody"
            :key="index"
            v-html="text">
          </div>
        </v-card-text>
        <!-- Legacy announcements have no attachments field; they must render
             exactly as they did before, with no empty section. -->
        <v-card-text v-if="attachments.length" class="announcement-attachments pt-0">
          <div class="caption grey--text mb-1">Attachments</div>
          <a
            v-for="attachment in attachments"
            :key="attachment.blobName"
            class="announcement-attachment d-block mb-1"
            :href="downloadUrl(attachment)"
            @click.prevent="download(attachment)">
            <v-icon small color="blue darken-1" class="mr-1">{{ icons.mdiPaperclip }}</v-icon>
            {{ attachment.filename }}
            <span v-if="humanSize(attachment.size)" class="caption grey--text ml-1">
              ({{ humanSize(attachment.size) }})
            </span>
          </a>
          <div
            v-if="attachmentError"
            class="announcement-attachment-error caption red--text">
            {{ attachmentError }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :class="`notification-dialogBox-close-btn`"
            text color="blue darken-1"
            @click="showNotificationDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiPaperclip } from '@mdi/js';
import { TMC_CONSTANTS } from '../../../util/shared/constants';
import { linkifyNotification, formatTimestamp } from './notificationUtil';
import { attachmentDownloadUrl, downloadAttachment, humanSize } from './attachmentUtil';

export default {
  name: 'NotificationDialog',
  props: {
    notification: {
      type: Object,
      default: () => ({}),
    },
    notificationDialog: {
      type: Boolean,
      default: false,
    },
    // Injectable so tests can drive the failure path without a client.
    downloader: {
      type: Function,
      default: downloadAttachment,
    },
  },
  data: () => ({
    icons: { mdiPaperclip },
    zIndexNotiDialog: TMC_CONSTANTS.COMPONENT_Z_INDEX.NOTIFICATION_DIALOG,
    attachmentError: '',
  }),
  watch: {
    notificationDialog() {
      // Reopening for another announcement must not carry over the last error.
      this.attachmentError = '';
    },
  },
  methods: {
    formatTimestamp,
    humanSize,
    downloadUrl(attachment) {
      return attachmentDownloadUrl(this.notification._id, attachment.blobName);
    },
    async download(attachment) {
      this.attachmentError = '';
      try {
        await this.downloader(this.notification._id, attachment);
      } catch (e) {
        this.attachmentError = `Could not download ${attachment.filename}. Please try again.`;
      }
    },
  },
  computed: {
    attachments() {
      return Array.isArray(this.notification.attachments) ? this.notification.attachments : [];
    },
    linkifiedBody() {
      return this.notification.body.split('\n').map((line) => linkifyNotification(line));
    },
    showNotificationDialog: {
      get() {
        return this.notificationDialog;
      },
      set(value) {
        this.$emit('showNotificationDialog', value);
      },
    },
  },
};
</script>

<style>
/*TODO Use this style instead of inline style for all the zindex also */
.notification-dialogBox {
  z-index: v-bind('zIndexNotiDialog');
};
.notification-body {
  color:black;
};
</style>
